var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"340px","width":"100%"}},[_c('canvas',{ref:"cv"})])
}
var staticRenderFns = []

export { render, staticRenderFns }